import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useAddCategoryMutation, useUpdateCategoryMutation } from "./Api";
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";

const AddCategory = ({
    mode = "add",
    onClose,
    onSave,
    data = null,
}) => {

    const [addCategoryApi, { isLoading }] = useAddCategoryMutation()
    const [updateCategoryApi, { isLoading: updateIsLoading }] = useUpdateCategoryMutation()

    const navigate = useNavigate()

    const validationSchema = Yup.object().shape({
        category: Yup.string()
            .required('Category Name is required')
            .matches(/^[A-Za-z ]+$/,
                "Enter valid Category Name")
            .trim(),
        status: Yup.string()
            .required('Status is required')
            .trim(),
    });

    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    useEffect(() => {
        if (data) {
            reset({
                category: data.category,
                status: data.status,
            });
        }
    }, [])

    const resetButton = () => {
        reset({
            category: "",
            status: "",
        });
    };

    const onSubmit = async (payload) => {
        try {
            if (mode == 'add') {

                const response = await addCategoryApi(payload)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {

                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }

                    ToastrService.error(response.error.data.message);
                }

            } else {

                const updateData = {
                    category: payload.category,
                    status: payload.status,
                    id: data.id,
                }
                const response = await updateCategoryApi(updateData)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {

                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }

                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <>
                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">

                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Create New Category" : "Manage Category"}
                                </h3>
                                <small className="text-muted">{mode === "add" ? "Fill in the details below to create a New Category." : "Update the details below to Manage Category"}</small>
                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>

                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Category Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="category"
                                        name='category'
                                        placeholder='Enter the Category name'
                                        {...register('category')}
                                        className="form-control"

                                    />
                                    {errors.category && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.category.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Status <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="status"
                                        name="status"
                                        {...register('status')}
                                        className="custom-select"
                                    >
                                        <option value="">Select status</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                    {errors.status && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.status.message}
                                        </p>
                                    )}

                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Create Category" : "Update Category"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>
                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default AddCategory;